<template>
  <div class="myModal" ref="myModal">
    <el-dialog
      title="提示"
      :visible.sync="showState"
      :before-close="cancel"
      :close-on-click-modal='false'
      :width="width"
    >
      <span slot="title" class="fsize28">{{ title }}</span>
      <slot name="content"></slot>
      <div class="list flex">
        <div class="box marginRt10" v-for="item in imgList" :key="item">
          <img class="pointer" @click="previewImage(item)" :src="item" alt="" />
        </div>
      </div>
      <slot name="footer"></slot>
      <span v-if="footer.slots == false" slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button class="blueBtn" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: [],
    },
    showState: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    footer: {
      type: Object,
      default() {
        return {
          footer: true,
          slots: true,
        };
      },
    },
    width: {
      type: String,
      default: "30%",
    },
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
    previewImage(src) {
      window.open(src);
    },
  },
};
</script>
<style lang="scss" scoped>
.list > .box {
  width: 33.33%;
  height: 140px;
  & > img {
    width: 100%;
    height: 100%;
  }
}
</style>